import { render, staticRenderFns } from "./TariffCard.vue?vue&type=template&id=6a1acba7&scoped=true&"
import script from "./TariffCard.vue?vue&type=script&lang=js&"
export * from "./TariffCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1acba7",
  null
  
)

export default component.exports